import { useTranslation } from 'react-i18next';

import { Select, Text } from '@/lib/v2/components';

import { useRuleDefaultOptions } from '@/modules/RulesModule/components/FormRule/hooks/useRuleDefaultOptions';
import { TRANSLATE_RULES_LABELS } from '@/modules/RulesModule/constants';
import { IFormProps, IRuleForm } from '@/modules/RulesModule/interfaces';

interface IRepeatedEmailsProps {
  loading?: boolean;
  form: IFormProps<IRuleForm>;
  disabled?: boolean;
}

const RepeatedEmails = ({ form, disabled = false }: IRepeatedEmailsProps) => {
  const { t } = useTranslation('rules');
  const { repeatEmailsOptions } = useRuleDefaultOptions();

  return (
    <div className="flex w-full flex-col items-start justify-start" id="repeated-emails">
      <Text className="mr-2 whitespace-nowrap" fontWeight="medium" variant="text">
        {t(`${TRANSLATE_RULES_LABELS}.repeatedEmails.title`)}
      </Text>
      <div className="mb-5 w-full flex-col items-center">
        <Text className="mr-2 whitespace-nowrap" variant="text">
          {t(`${TRANSLATE_RULES_LABELS}.repeatedEmails.description`)}
        </Text>
        <Select
          isRequired
          control={form.control}
          disabled={disabled}
          name="repeatEmails"
          options={repeatEmailsOptions}
        />
      </div>
    </div>
  );
};

export default RepeatedEmails;
